export default "__VITE_ASSET__Baalw9W___"